import React, { ReactNode, useState } from "react";
import { TGameOptions } from "../../types";
import CyberClashIcon from "../common/Icons/CyberClashIcon";
import DeathSquadIcon from "../common/Icons/DeathSquadIcon";
import KitchenPanicIcon from "../common/Icons/KitchenPanicIcon";

interface IProps {
  title: TGameOptions;
  children: ReactNode;
}

const GameInfomation: React.FC<IProps> = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className={`tw-border-[2px] tw-rounded-[15px] tw-bg-[#393B41] tw-overflow-hidden tw-my-[10px] ${
        title === "Zombies" ? "tw-border-[#C53CFF]" : title === "CyberClash" ? "tw-border-[#C53CFF]" : "tw-border-[#7886FF]"
      }`}
    >
      <div className="tw-flex tw-items-center tw-justify-between tw-p-4 tw-cursor-pointer" onClick={toggleAccordion}>
        <div className="tw-flex tw-items-center tw-gap-[27px]">
          {title === "CyberClash" ? (
            <span className="tw-rounded-lg tw-w-[49px] tw-h-[46px] tw-bg-[#C53CFF] tw-flex tw-items-center tw-justify-center">
              <CyberClashIcon />
            </span>
          ) : title === "Zombies" ? (
            <span className="tw-rounded-lg tw-w-[49px] tw-h-[46px] tw-bg-[#9D62FE] tw-flex tw-items-center tw-justify-center">
              <DeathSquadIcon />
            </span>
          ) : (
            <span className="tw-rounded-lg tw-w-[49px] tw-h-[46px] tw-bg-[#7886FF] tw-flex tw-items-center tw-justify-center">
              <KitchenPanicIcon />
            </span>
          )}
          <div className="tw-text-white tw-text-2xl tw-font-semibold">{title === "Zombies" ? "Death Squad" : title === "CyberClash" ? "Cyber Clash" : title}</div>
        </div>
        <span className="tw-h-[33px] tw-w-[33px] tw-bg-[#9ca3af] tw-flex tw-items-center tw-justify-center tw-rotate-180 tw-rounded-full">
          <span className="tw-text-white tw-text-center tw-font-bold">!</span>
        </span>
      </div>
      {isOpen && <div className="tw-p-4 tw-bg-gray-100" dangerouslySetInnerHTML={{ __html: children as string }} />}
    </div>
  );
};

export default GameInfomation;
